var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachDesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_24_filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16V4C22 2.89543 21.1046 2 20 2H4ZM15.1142 8.8572L13.1428 6.88574L8.42493 11.6079C7.99518 12.0377 7.67761 12.5665 7.50016 13.1477L7.00784 14.7605C6.96596 14.8977 7.0989 15.0349 7.23934 14.992L8.85217 14.4996C9.43332 14.3222 9.96198 14.0047 10.3917 13.575L15.1142 8.8572ZM16.7558 6.03225L15.9678 5.24412C15.6422 4.91864 15.1145 4.91862 14.789 5.2441L13.9499 6.08573L15.9143 8.05004L16.8131 7.14774C17.0801 6.82034 17.061 6.33741 16.7558 6.03225Z",
    fill: "#99A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36583",
    d: "M6.5 22C5.94772 22 5.5 21.5523 5.5 21L5.5 19L7.5 19L7.5 21C7.5 21.5523 7.05228 22 6.5 22Z",
    fill: "#99A2AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36584",
    d: "M18 22C17.4477 22 17 21.5523 17 21L17 19L19 19L19 21C19 21.5523 18.5523 22 18 22Z",
    fill: "#99A2AD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36585",
    x: 7,
    y: 19,
    width: 10,
    height: 1,
    fill: "#99A2AD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachDesk);
export default __webpack_public_path__ + "static/media/attach_desk.9598fc59b59bf51046150d816505536b.svg";
export { ForwardRef as ReactComponent };